import { InfiniteData, useMutation, useQueryClient } from '@tanstack/react-query';
import { UserDTO } from '../../../apiclients/bstinsights';
import useBSTInsightsAPI from '../../../apiclients/api/bstinsightsapi';
import useAcquireToken from '../../AuthToken/Hooks/useAcquireToken';
import { useGetUsersPagedQueryKey } from './useGetUsersPaged';
import { useGridDataQueryInvalidate } from './useGridDataQueryInvalidate';

export const useUpdateUser = () => {
  const queryClient = useQueryClient();
  const { updateUser } = useBSTInsightsAPI();
  const { getTokenSilently } = useAcquireToken();
  const gridQueryKey = useGetUsersPagedQueryKey()
  const invalidateGridQuery = useGridDataQueryInvalidate();

  return useMutation({
    mutationFn: async ({ user }: { user: UserDTO }) => {
      const token = await getTokenSilently();
      if (!token) return;
      await updateUser(token, Number(user.userId), {
        displayName: user.displayName,
        email: user.mail,
        jobTitle: user.employeeTitle,
      });
    },
    onMutate: async ({ user }) => {
      const prevValue: InfiniteData<UserDTO[], unknown> | undefined =
        queryClient.getQueryData(gridQueryKey);
      /* istanbul ignore next */
      if (prevValue) {
        const data = {
          ...prevValue,
          pages: prevValue.pages.map((page) => {
            const rowIdx = page.findIndex(
              (item) => item.userId === user.userId
            );
            return rowIdx !== -1
              ? [...page.slice(0, rowIdx), user, ...page.slice(rowIdx + 1)]
              : page;
          }),
        };
        queryClient.setQueryData(gridQueryKey, data);
      }
      return { prevValue };
    },
    onSettled: invalidateGridQuery
  });
};
